module.exports = __webpack_public_path__ + "15300dfcc193594c91bf1b8f46f76363.png";